import { render, staticRenderFns } from "./product-layout.vue?vue&type=template&id=3c3ba4d6"
import script from "./product-layout.vue?vue&type=script&lang=js"
export * from "./product-layout.vue?vue&type=script&lang=js"
import style0 from "./product-layout.vue?vue&type=style&index=0&id=3c3ba4d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports